const SeoFragment = `
fragment SeoFragment on PostTypeSEO {
	fullHead
}
`;

export default SeoFragment;
